import {
  FETCH_DASHBOARD_LIST_FAILURE,
  FETCH_DASHBOARD_LIST_REQUEST,
  FETCH_DASHBOARD_LIST_SUCCESS,
} from './type';

const initialState = {
  isLoading: false,
  error: '',
  dashboardList: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DASHBOARD_LIST_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_DASHBOARD_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        dashboardList: action.payload,
        error: '',
      };

    case FETCH_DASHBOARD_LIST_FAILURE:
      return {
        ...state,
        isLoading: false,
        dashboardList: [],
        error: action.payload,
      };

    default:
      return state;
  }
};
export default reducer;
